module.exports = __webpack_public_path__ + "img/resized-APP-0008-2.8151131f.png";